var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectsGoToConsole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.923096H25V22.0769H0V0.923096ZM1.92307 4.76925V20.1539H23.0769V4.76925H1.92307ZM3.84615 7.65387H6.73077L9.61537 11.5L6.73077 15.3462H3.84615L6.73077 11.5L3.84615 7.65387Z",
    fill: "#0C6CDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsGoToConsole);
export default __webpack_public_path__ + "static/media/projects_goToConsole.e439a7ebcb45a0fbdd863f8de2fa85aa.svg";
export { ForwardRef as ReactComponent };